/* src/app/features/contratacao/operacao/liberacao/liberacao-detalhe.component.scss */
form {
  margin-bottom: 60px;
}
.fa-question-circle {
  vertical-align: bottom;
}
.help-remove {
  margin-bottom: 4px;
}
.help-subtitulo {
  color: #495057;
  font-size: 1rem;
  vertical-align: middle;
}
.coluna-moeda {
  text-align: right;
}
/*# sourceMappingURL=liberacao-detalhe.component.css.map */
